module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-11-c041d1b8597ac60894ecc6d4232a1579.svg";